export interface ISMU {
    SMUID: number;
    SMUName: string;
}
export interface IEngagementType {
    EngagementTypeID: number;
    EngagementTypeName: string;
}
export interface IEngagementSubType {
    EngagementSubTypeID: number;
    EngagementSubTypeName: string;
}
export interface IMarketSegment {
    MarketsegmentID: number;
    MarketSegmentName: string;
}
export interface IEngagementSector {
    EngagementSectorID: number;
    EngagementSectorName: string;
}
export interface IEngagementSubSector {
    EngagementSubSectorID: string;
    EngagementSubSectorName: string;
}
export interface IGeographicalType {
    GeographicalID: string;
    GeographicalName: string;
}
export interface IDesignation {
    DesignationID: string;
    DesignationName: string;
}
export interface IViewRequestDetailsFilters {
    SMUList: Array<ISMU>;
    EngagementTypeList: Array<IEngagementType>;
    EngagementSubTypeList: Array<IEngagementSubType>;
    MarketSegmentList: Array<IMarketSegment>;
    EngagementSectorList: Array<IEngagementSector>;
    EngagementSubSectorList: Array<IEngagementSubSector>;
    GeographicalTypeList: Array<IGeographicalType>;
    DesignationList: Array<IDesignation>;
}

export interface IViewRequestDetailsParameters {  
    SMUList: Array<ISMU> | null | undefined;
    EngagementTypeList: Array<IEngagementType> | null | undefined;
    EngagementSubTypeList: Array<IEngagementSubType> | null | undefined;
    MarketSegmentList: Array<IMarketSegment> | null | undefined;
    EngagementSectorList: Array<IEngagementSector> | null | undefined;
    EngagementSubSectorList: Array<IEngagementSubSector> | null | undefined;
    GeographicalTypeList: Array<IGeographicalType> | null | undefined; 
    DesignationList: Array<IDesignation> | null | undefined; 
}


export class EducationDetails{
    EducationDetailsId;
    ResumeId;
    Qualification;
    CourseName;
    CountryName;
    CountryId;
    CityName;
    CityId;
    CourseType;
    Country;
    City;
    isDeleted;

}